import { GiftCardConfirmationScreen } from '../../../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function GiftCardConfirmation() {
  return <GiftCardConfirmationScreen />;
}
